import React from 'react';
import { ThemeProvider, StylesProvider, Theme as ThemeType } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import createGenerateClassName from '@material-ui/styles/createGenerateClassName';

const generateClassName = createGenerateClassName({
  productionPrefix: 'm',
});
import MinekoTheme from './MinekoTheme';

interface Props {
  children: React.ReactNode;
  theme?: ThemeType;
}
const BasicTheme: React.FC<Props> = ({ children, theme }: Props) => (
  <ThemeProvider theme={theme || MinekoTheme}>
    <StylesProvider generateClassName={generateClassName} injectFirst>
      <CssBaseline />
      {children}
    </StylesProvider>
  </ThemeProvider>
);

export default BasicTheme;
